import React, { Component } from 'react';
import Flatpickr from 'react-flatpickr';

const pickerHandler = (handler) => (dates, dateStr) => handler(dateStr);

class InputOrFlatpickr extends Component<Object, Object> {
  state = {
    supportsDate: true
  }

  render() {
    if (this.state.supportsDate) {
      return <input ref="input" {...this.props} />
    } else {
      return <Flatpickr {...this.props} onChange={pickerHandler(this.props.onChange)} onClose={this.props.onBlur} />;
    }
  }

  componentDidMount() {
    const { input } = this.refs;
    if (input.type === 'text') {
      this.setState({supportsDate: false});
    }
  }
}

export default InputOrFlatpickr;